/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ButtonToolbar, ToggleButtonGroup, HelpBlock } from 'react-bootstrap';
import ItemTitle from '../ItemTitle';
/* eslint-disable jsx-a11y/aria-role */

class CheckboxforInput extends React.Component {
    constructor() {
        super();
        this.state = {
            isChecked: false
        }
    }
    handleOnClick = (event) => {
            const isChecked = event.target.checked;
            const { content, handleCheckboxChange } = this.props;
            handleCheckboxChange(content.questionRel, !isChecked ? [] : [event.target.value])
            this.setState({
                isChecked
            })
        }
    render() {
        const {
            content
        } = this.props;
        const questionObj = {
            questionMark: content.questionMark,
            question: content.question,
            questionTip: content.questionTip
        };
        const questionTitle = (content.question && content.question.title && content.question.title) || '';
        const errorId = content.checkboxItems[0].dataKey + '0-err';
        
        const { isChecked } = this.state;
        return (
            <div className="checkbox-box">
                <FormGroup validationState={content.isError ? 'error' : null}>
                    {content.question && content.question.title &&
                        <ItemTitle content={questionObj} isNeedLabel={false} />
                    }
                    <ButtonToolbar>
                        <ToggleButtonGroup
                            //onChange={handleOnChangeAction}
                            type="checkbox"
                            name={content.checkboxName}
                            defaultValue={content.defaultValue}
                            className={content.isDisabled ? "checkbox-decoration tc-disabled" : "checkbox-decoration"}
                            role={'group'} //group
                            aria-label={questionTitle || 'questionTitle'}//A string value marks the current element.
                        >
                            {content.checkboxItems.map((item, i) =>
                                <label data-key={item.dataKey}
                                    aria-label={content.ariaLabel || questionTitle + ' ' + (item.display && item.display)}
                                    aria-describedby={`${item.dataKey}${i}-err`}
                                    type="button"
                                    className={isChecked ? "btn btn-default active" : "btn btn-default" }
                                    onClick={this.handleOnClick}
                                    key={i}
                                >
                                    <input type="checkbox" name="privacy" aria-describedby={`${item.dataKey}${i}-tip`} value={item.value} />
                                    <i className="before-icon"></i>{item.display}
                                </label>
                            )}
                        </ToggleButtonGroup>
                    </ButtonToolbar>
                    <HelpBlock id={errorId}>{content.errorMessage}</HelpBlock>
                </FormGroup>
            </div>
        )
    }
}
CheckboxforInput.propTypes = {
    content: PropTypes.object.isRequired,
    handleCheckboxChange: PropTypes.func
};

CheckboxforInput.defaultProps = {
    content: {}
};

export default CheckboxforInput;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/CheckboxforInput/CheckboxforInput.js